import { showErrorApiResponseSnackbar } from '../snackbar';
const showApiErrorSnackbar = (props) => () => {
    if (!props)
        return;
    // if function is called from queryFn, then `error` is `FetchBaseQueryError`, otherwise `error` is `MutationApiError`.
    const extractErrorProps = 'error' in props.error ? { ...props, error: props.error.error } : props;
    showErrorApiResponseSnackbar(extractErrorProps);
};
export { showApiErrorSnackbar };
